const yesNoFilters = ["isPromoted", "isOpenForComment"];

export default yesNoFilters;



// WEBPACK FOOTER //
// ./src/state/yesNoFilters.js